import { useState, useEffect, useRef } from "react";
import { ChangeAlertCallbackType } from "../../../Root";
import { FeatureService } from "../../../../services/FeatureService";
import { CustomerService } from "../../../../services/CustomerService";
import { REGEX_TAXID, REGEX_PHONE, REGEX_EMAIL, REGEX_UUID } from "../../../../util/RegEx";

export const useCustomerAdd = (open: boolean, changeAlert: ChangeAlertCallbackType, type: string, handleGet: Function, onClose) => {
    const featureService = useRef<FeatureService>();
    const customerService = useRef<CustomerService>();
    
    const [isValidForm, setIsValidForm] = useState<boolean>(true);
    const [form, setForm] = useState({});
    const [loading, setLoading] = useState({});
    const [phoneCode, setPhoneCode] = useState("52");
    const [zPos, setZPos] = useState(45);

    const onHandleConfirm = async () => {
        setLoading(true);
        setZPos(-1);

        let f = form;
        f["customer"]["phone"] = `+${phoneCode}${form["customer"]["phone"]}`;
        
        const response = await customerService.current.customerVipAdd(f);
        if (response["data"].response === "OK") {
            setLoading(false);
            setZPos(45);
            changeAlert(true, "success", "El cliente se agregó con éxito");
            onClose();
            handleGet(true);
        } else {
            setLoading(false);
            setZPos(45);
            changeAlert(true, "error", response["data"].message || "El cliente no pudo ser creado");
        }
    };

    const onHandleChange = (key, key2, e) => {
        let f = form;
        let value = e.target.value;

        if(key && key2){
            f[key] ?
			f[key][key2] = value :
			f[key] = {[key2]: value }
		}

        setForm(JSON.parse(JSON.stringify(f)));
        validateForm(f);
    };

    const onHandlePhone = (e) => {
        let value = e.target.value;
        setPhoneCode(value);
    };

    const validateForm = (f) => {
        if (REGEX_UUID.test(f["customer"]["uuid"]) && REGEX_PHONE.test(`+${phoneCode}${f["customer"]["phone"]}`) && REGEX_TAXID.test(f["customer"]["taxid"]) && REGEX_EMAIL.test(f["customer"]["email"])) {
            setIsValidForm(false);
        } else {
            setIsValidForm(true);
        }
    };

    useEffect(() => {
        if (!open) {
            setIsValidForm(true)
            setForm({});
            setZPos(45);
        } else {
            let user = JSON.parse(localStorage.session);
            let payload = {
                customer: {
                    uuid: "",
                    phone: "",
                    taxid: "",
                    email: ""
                },
                active: true,
                created_by: user["email"],
                type: type
            }
            type === "customer" && (payload["validation"] = "default");
            setForm(payload);
        }
        featureService.current = new FeatureService(changeAlert);
        customerService.current = new CustomerService(changeAlert);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open]);

    return {
        zPos,
        form,
        isValidForm,
        phoneCode,
        loading,
        onHandlePhone,
        onHandleChange,
        onHandleConfirm
    };
};
